import React from "react";

// `fit` — "cover" (default) crops a photo to fill the frame; "contain" keeps
// a logo whole, for brand identities (see utils/user-identity).
export default function Avatar({ user, size = 40, rounded = true, status, fit = "cover" }) {
  if (!user) return null;

  const { first_name, last_name, profile_picture_url, colour_code } = user;
  const initials = `${first_name?.charAt(0) || ""}${last_name?.charAt(0) || ""}`;
  const avatarSize = { width: size, height: size };
  const borderRadius = rounded ? "9999px" : "8px";

  const statusColor =
    status === "ONLINE" ? "bg-success" : status === "OFFLINE" ? "bg-text_muted" : "";

  return (
    <div className="relative inline-block">
      {profile_picture_url ? (
        <img
          src={profile_picture_url}
          alt={`${first_name} ${last_name}`}
          style={{ ...avatarSize, borderRadius }}
          className={`border border-border ${fit === "contain" ? "object-contain bg-surface" : "object-cover"}`}
        />
      ) : (
        <div
          style={{ ...avatarSize, borderRadius, backgroundColor: colour_code || "#7158EF" }}
          className="flex items-center justify-center text-white font-semibold select-none"
        >
          {initials}
        </div>
      )}

      {status && (
        <span
          className={`absolute bottom-0 right-0 w-3 h-3 rounded-full border-2 border-surface ${statusColor}`}
        />
      )}
    </div>
  );
}
